<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Tunai</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalTunai | currency }} ({{ totalDiscountTunai | currency }})
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Transfer Bank</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalTransfer | currency }} ({{ totalDiscountTransfer| currency }})
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Giro</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalGiro | currency }} ({{ totalDiscountGiro | currency }})
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Uang Muka</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalUangMuka | currency }} ({{ totalDiscountUangMuka | currency }})
                    <!-- {{ totalUangMukaTunai | currency }} {{ totalUangMukaTransfer | currency }} -->
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <!-- <div class="col-md-2">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Tunai Transfer</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalTunai + totalTransfer | currency }}
                  </span>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Disc. (C/B)</span></h5>
                <h3 class="my-3">
                  <span>{{ totalDiscountTunaiTransfer | currency }}</span>
                </h3>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Tunai Report</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalTunaiReport | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Transfer Bank Report</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalTransferReport | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Giro Report</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalGiroReport | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Uang Muka Report</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalUangMukaReport | currency }}
                    <!-- {{ totalUangMukaTunaiReport | currency }} -->
                    <!-- {{ totalUangMukaTransferReport | currency }} -->
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Subtotal Tunai Transfer</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalSubtotalTunaiTransfer | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-2">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Subtotal Giro Cair</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalSubtotalGiroCair | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Subtotal Giro Belum Cair</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalSubtotalGiroBelumCair | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-2">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Uang Muka Pelunasan</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalUangMukaPelunasan | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-2">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Rounding</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    <span class="badge badge-success">{{ totalRoundingPlus | currency }}</span>
                    <span class="badge badge-danger">{{totalRoundingMinus | currency }}</span>
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
          <!-- totalDenda -->
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Tunai Transfer</span></h5>
                <h3 class="my-3">
                  <span>
                    {{ ((totalTunai + totalDiscountTunai) + (totalTransfer + totalDiscountTransfer) - (totalUangMukaTunai + totalUangMukaTransfer)) - totalDenda - totalRoundingPlus + Math.abs(totalRoundingMinus) + totalUangMukaPelunasan | currency }}
                    <!--  -->
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Denda</span></h5>
                <h3 class="my-3">
                  <span>
                    {{ totalDenda | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Uang Muka Tunai</span></h5>
                <h3 class="my-3">
                  <span>
                    {{ totalUangMukaTunai | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Uang Muka Transfer</span></h5>
                <h3 class="my-3">
                  <span>
                    {{ totalUangMukaTransfer | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Penerimaan Tagihan</h4>
                        <div class="form-inline">
                          <span><b>Salesman:</b></span>
                          <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom vsc-custom-inline"/>
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Date:</b></span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary" @click="processReport" v-if="authUser.permissions.laporan_penerimaan_tagihan_process">Process</button>
                            <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('sales')">PDF Per Sales</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('group')">PDF Per Date</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel_sales')">Excel Sales</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel_group')">Excel Date</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="alert alert-info" role="alert" >
              Data dihitung mulai dari <strong>Tanggal dibuat</strong>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#report-payment" data-toggle="tab" aria-expanded="false" class="nav-link active">Data Payment</a></li>
                            <li class="nav-item"><a href="#report-group" data-toggle="tab" aria-expanded="false" class="nav-link">Group Data</a></li>
                            <li class="nav-item"><a href="#json" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="report-payment">
                              <div v-for="i in dataRaw" :key="i.id">
                                <div v-for="a in i.areas" :key="a.name">
                                    <h5 style="margin-top: 50px" class="text-center"><b>{{ i.date | dateFormat("DD/MM/YYYY") }}</b></h5>
                                    <h5 class="text-center">
                                      <b v-if="i.salesman == null">Null</b>
                                      <b v-else>{{ i.salesman }}</b>
                                    </h5>
                                    <h5 class="text-center">{{ a.name }}</h5>
                                    <div class="table-responsive">
                                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                                            <thead>
                                                <th>#</th>
                                                <th>Ref No.</th>
                                                <th>Type</th>
                                                <th>Method</th>
                                                <th>Customer</th>
                                                <th>Date</th>
                                                <th>Finish Date</th>
                                                <th class="text-right">Retur</th>
                                                <th class="text-right">Uang Muka</th>
                                                <th class="text-right">Subtotal</th>
                                                <th class="text-right">Discount</th>
                                                <th class="text-right">Tax</th>
                                                <th class="text-right">Round</th>
                                                <th class="text-right">Denda</th>
                                                <th class="text-right">Payment</th>
                                                <th class="text-right">Total</th>
                                                <th class="text-right">Outstanding</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="s in a.saleColl" :key="s.id">
                                                    <td>
                                                      <span v-if="authUser.permissions.laporan_penerimaan_tagihan_process">
                                                        <label v-if="s.type === 'payment'" class="form-checkbox">
                                                          <input type="checkbox" :value="s.id" v-model="selected"><i class="form-icon"></i>
                                                        </label>
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span v-if="s.type === 'sales'" class="ml-5 text-ref-sales" @click="showSaleNo(s.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.ref_no}}</span>
                                                      <span v-else-if="s.type === 'purchasing'" class="ml-5 text-ref-sales" @click="showSaleNo(s.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.ref_no}}</span>
                                                      <span v-else data-toggle="modal" @click="showPaymentNo(s.ref_no)" data-target="#modalPaymentGroup" data-backdrop="static" data-keyboard="false"><b>{{ s.ref_no }}</b></span>
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-success" v-if="s.type === 'payment'">{{ s.type }}</span>
                                                        <span class="badge badge-warning" v-else-if="s.type === 'sales'">{{ s.type }}</span>
                                                        <span class="badge badge-primary" v-else>{{ s.type }}</span>

                                                        <span class="ml-1 badge badge-info" v-if="s.category !== null && s.category !== 'sales'">{{ s.category }}</span>
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                                        <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                                        <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                                    </td>
                                                    <td>
                                                      <span v-if="s.type === 'sales'">{{ s.customer }}</span>
                                                      <span v-else-if="s.type === 'purchasing'">{{ s.customer }}</span>
                                                      <span v-else>{{ s.customer }}</span>
                                                    </td>
                                                    <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                                    <td>
                                                      <span v-if="s.method === 'Giro'"><b>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</b></span>
                                                      <span v-else>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</span>
                                                    </td>
                                                    <td class="text-right">{{ s.retur_total | currency }}</td>
                                                    <td class="text-right">{{ s.uangmuka | currency }}</td>
                                                    <td class="text-right">{{ s.subtotal - s.uangmuka | currency }}</td>
                                                    <td class="text-right">{{ s.discount | currency }}</td>
                                                    <td class="text-right">{{ s.tax | currency }}</td>
                                                    <td class="text-right">{{ s.round | currency }}</td>
                                                    <td class="text-right">{{ s.penalty_amount | currency }}</td>
                                                    <td class="text-right">{{ s.payment_amount | currency }}</td>
                                                    <td class="text-right">{{ s.total | currency }}</td>
                                                    <td class="text-right">{{ s.outstanding | currency }}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Tunai</b></td>
                                                <td class="text-right">
                                                  {{ a.total_tunai_report | currency }}
                                                </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Transfer</b></td>
                                                <td class="text-right">
                                                  {{ a.total_transfer_report | currency }}
                                                </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Giro</b></td>
                                                <td class="text-right">
                                                  {{ a.total_giro_report | currency }}
                                                </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Uang Muka</b></td>
                                                <td class="text-right">
                                                  {{ a.total_uangmuka_report | currency }}
                                                </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Uang Muka Pelunasan</b></td>
                                                <td class="text-right">
                                                  {{ a.total_uangmuka_pelunasan | currency }}
                                                </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Denda</b></td>
                                                <td class="text-right">
                                                  {{ a.total_penalty_amount | currency }}
                                                </td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <td colspan="15" class="text-right"><b>Total</b></td>
                                                <td class="text-right">{{ a.total_report | currency }}</td>
                                                <td></td>
                                              </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="report-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <span>Total Tunai Group: {{ totalTunaiGroup | currency }} ({{ countTunaiGroup }})</span><br>
                                  <span>Total Transfer Group: {{ totalTransferGroup | currency }} ({{ countTransferGroup }})</span><br>
                                  <span>Total Group: {{ totalTunaiGroup + totalTransferGroup | currency }}</span>
                                </div>
                                <div class="col-md-6">
                                  <span>Total Tunai: {{ totalTunai | currency }} ({{ countTunai }})</span><br>
                                  <span>Total Transfer: {{ totalTransfer | currency }} ({{ countTransfer }})</span><br>
                                  <span>Total: {{ totalTunai + totalTransfer | currency }}</span>
                                </div>
                              </div>
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Sale No.</th>
                                    <th>Tanda Terima</th>
                                    <th>Payment No.</th>
                                    <th>Type</th>
                                    <th>Method</th>
                                    <th>Customer</th>
                                    <th>Sale Date</th>
                                    <th>Due Date</th>
                                    <th>Payment Date</th>
                                    <th class="text-right">Retur</th>
                                    <th class="text-right">Uang Muka</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Round</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Total</th>
                                    <!-- <th class="text-right">Outstanding</th> -->
                                  </thead>
                                  <tbody>
                                    <tr v-for="s in groups" :key="s.id">
                                        <td><span>{{ s.ref_no}}</span></td>
                                        <td><span v-if="s.check_tanda_terima === true"><i class="fa fa-check" style="color:green"></i></span></td>
                                        <td><span>{{ s.ref_no2}}</span></td>
                                        <td><span class="badge badge-success">{{ s.type }}</span></td>
                                        <td>
                                          <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                          <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                          <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                        </td>
                                        <td>{{ s.customer }}</td>
                                        <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ s.due_date | dateFormat('DD/MM/YYYY')}}</td>
                                        <td>
                                          <span v-if="s.method === 'Giro'"><b>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</b></span>
                                          <span v-else>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</span>
                                        </td>
                                        <td class="text-right">{{ s.retur_total | currency }}</td>
                                        <td class="text-right">{{ s.uangmuka | currency }}</td>
                                        <td class="text-right">{{ s.subtotal | currency }}</td>
                                        <td class="text-right">{{ s.discount | currency }}</td>
                                        <td class="text-right">{{ s.tax | currency }}</td>
                                        <td class="text-right">{{ s.round | currency }}</td>
                                        <td class="text-right">{{ s.payment_amount | currency }}</td>
                                        <td class="text-right">{{ s.total | currency }}</td>
                                        <!-- <td class="text-right">{{ s.outstanding }}</td> -->
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                  </tfoot>
                                </table>
                              </div>
                              <!-- getGiroDiscount -->
                              <h5>Sale By Giro discount not null</h5>
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Sale No.</th>
                                    <th>Payment No.</th>
                                    <th>Type</th>
                                    <th>Method</th>
                                    <th>Customer</th>
                                    <th>Sale Date</th>
                                    <th>Due Date</th>
                                    <th>Payment Date</th>
                                    <th class="text-right">Retur</th>
                                    <th class="text-right">Uang Muka</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Tax</th>
                                    <th class="text-right">Round</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Total</th>
                                    <!-- <th class="text-right">Outstanding</th> -->
                                  </thead>
                                  <tbody>
                                    <tr v-for="s in getGiroDiscount" :key="s.id">
                                        <td>
                                            <span>{{ s.ref_no}}</span>
                                        </td>
                                        <td>
                                            <span>{{ s.ref_no2}}</span>
                                        </td>
                                        <td>
                                            <span class="badge badge-success">{{ s.type }}</span>
                                        </td>
                                        <td>
                                            <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                            <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                            <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                        </td>
                                        <td>{{ s.customer }}</td>
                                        <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ s.due_date | dateFormat('DD/MM/YYYY')}}</td>
                                        <td>
                                          <span v-if="s.method === 'Giro'"><b>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</b></span>
                                          <span v-else>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</span>
                                        </td>
                                        <td class="text-right">{{ s.retur_total | currency }}</td>
                                        <td class="text-right">{{ s.uangmuka | currency }}</td>
                                        <td class="text-right">{{ s.subtotal | currency }}</td>
                                        <td class="text-right">{{ s.discount | currency }}</td>
                                        <td class="text-right">{{ s.tax | currency }}</td>
                                        <td class="text-right">{{ s.round | currency }}</td>
                                        <td class="text-right">{{ s.payment_amount | currency }}</td>
                                        <td class="text-right">{{ s.total | currency }}</td>
                                        <!-- <td class="text-right">{{ s.outstanding }}</td> -->
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="json">
                              <div v-for="i in dataRaw" :key="i.id">
                                <div v-for="a in i.areas" :key="a.name">
                                  <h5 style="margin-top: 50px" class="text-center"><b>{{ i.date | dateFormat("DD/MM/YYYY") }}</b></h5>
                                  <h5 class="text-center">
                                    <b v-if="i.salesman == null">Null</b>
                                    <b v-else>{{ i.salesman }}</b>
                                  </h5>
                                  <h5 class="text-center">{{ a.name }}</h5>
                                  <div class="table-responsive">
                                      <table class="table table-item mb-0 table-sm table-striped table-hover">
                                          <thead>
                                            <th>Sale No.</th>
                                            <th>Payment No.</th>
                                            <th>Type</th>
                                            <th>Method</th>
                                            <th>Customer</th>
                                            <th>Sale Date</th>
                                            <th>Due Date</th>
                                            <th>Payment Date</th>
                                            <th class="text-right">Retur</th>
                                            <th class="text-right">Uang Muka</th>
                                            <th class="text-right">Subtotal</th>
                                            <th class="text-right">Discount</th>
                                            <th class="text-right">Tax</th>
                                            <th class="text-right">Round</th>
                                            <th class="text-right">Payment</th>
                                            <th class="text-right">Total Payment</th>
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Outstanding</th>
                                          </thead>
                                          <tbody>
                                            <tr v-for="s in a.saleCollGroup" :key="s.id">
                                              <td>
                                                  <span>{{ s.ref_no}}</span>
                                              </td>
                                              <td>
                                                  <span>{{ s.ref_no2}}</span>
                                              </td>
                                              <td>
                                                  <span class="badge badge-success">{{ s.type }}</span>
                                              </td>
                                              <td>
                                                  <span class="badge badge-primary" v-if="s.method === 'Tunai'">{{ s.method }}</span>
                                                  <span class="badge badge-info" v-else-if="s.method === 'Giro'">{{ s.method }}</span>
                                                  <span class="badge badge-warning" v-else>{{ s.method }}</span>
                                              </td>
                                              <td>{{ s.customer }}</td>
                                              <td>{{ s.date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>{{ s.due_date | dateFormat('DD/MM/YYYY')}}</td>
                                              <td>
                                                <span v-if="s.method === 'Giro'"><b>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</b></span>
                                                <span v-else>{{ s.finish_date | dateFormat('DD/MM/YYYY')}}</span>
                                              </td>
                                              <td class="text-right">{{ s.retur_total | currency }}</td>
                                              <td class="text-right">{{ s.uangmuka | currency }}</td>
                                              <td class="text-right">{{ s.subtotal | currency }}</td>
                                              <td class="text-right">{{ s.discount | currency }}</td>
                                              <td class="text-right">{{ s.tax | currency }}</td>
                                              <td class="text-right">{{ s.round | currency }}</td>
                                              <td class="text-right">{{ s.payment_amount | currency }}</td>
                                              <td class="text-right">{{ s.payment_total | currency }}</td>
                                              <td class="text-right">{{ s.total | currency }}</td>
                                              <td class="text-right">{{ s.outstanding | currency }}</td>
                                            </tr>
                                          </tbody>
                                          <tfoot>
                                            <tr>
                                              <td colspan="15" class="text-right"><b>Tunai</b></td>
                                              <td class="text-right">
                                                {{ a.total_tunai | currency }}
                                              </td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="15" class="text-right"><b>Transfer</b></td>
                                              <td class="text-right">
                                                {{ a.total_transfer | currency }}
                                              </td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="15" class="text-right"><b>Giro</b></td>
                                              <td class="text-right">
                                                {{ a.total_giro | currency }}
                                              </td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="15" class="text-right"><b>Uang Muka</b></td>
                                              <td class="text-right">
                                                {{ a.total_uangmuka | currency }}
                                              </td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td colspan="15" class="text-right"><b>Total</b></td>
                                              <td class="text-right">{{ a.total | currency }}</td>
                                              <td></td>
                                            </tr>
                                          </tfoot>
                                      </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <SaleModal />
        <PaymentGroupModal />
        <div class="row">
          <!-- <div class="col-md-6"><pre>{{ dataRaw }}</pre></div> -->
          <!-- <div class="col-md-6"><pre>{{ groups }}</pre></div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { paymentUrl, reportTransactionUrl, reportUrl, getHeader, report2Url, customerUrl } from '../../config'
import DatePicker from 'vue2-datepicker'
import SaleModal from '@/components/sales/SaleModal.vue'
import PaymentGroupModal from '@/components/payment/PaymentGroupModal.vue'

export default {
  name: 'PiutangSalesman',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    SaleModal,
    PaymentGroupModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loadingSales: true,
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    totalUangMukaTunai () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sales = area[z].saleColl
          for (let x = 0; x < sales.length; x++) {
            if (sales[x].method_id === 4) {
              if (sales[x].account_type === 'tunai') {
                sum += parseFloat(sales[x].total)
              }
            }
          }
        }
      }
      return sum
    },
    totalUangMukaTunaiReport () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sales = area[z].saleColl
          for (let x = 0; x < sales.length; x++) {
            if (sales[x].report_count > 0) {
              if (sales[x].method_id === 4) {
                if (sales[x].account_type === 'tunai') {
                  sum += parseFloat(sales[x].total)
                }
              }
            }
          }
        }
      }
      return sum
    },
    totalUangMukaTransferReport () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sales = area[z].saleColl
          for (let x = 0; x < sales.length; x++) {
            if (sales[x].report_count > 0) {
              if (sales[x].method_id === 4) {
                if (sales[x].account_type === 'transfer') {
                  sum += parseFloat(sales[x].total)
                }
              }
            }
          }
        }
      }
      return sum
    },
    totalUangMukaTransfer () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sales = area[z].saleColl
          for (let x = 0; x < sales.length; x++) {
            if (sales[x].method_id === 4) {
              if (sales[x].account_type === 'transfer') {
                sum += parseFloat(sales[x].total)
              }
            }
          }
        }
      }
      return sum
    },
    getGiroDiscount () {
      var array = this.dataRaw
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              loop.push(sale[c])
            }
          }
        }
      }
      return loop
    },
    totalSubtotalTunaiTransfer () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Tunai') {
              sum += parseFloat(sale[c].subtotal)
            }
            if (sale[c].method === 'Transfer Bank') {
              sum += parseFloat(sale[c].subtotal)
            }
          }
        }
      }
      return sum
    },
    totalSubtotalGiroCair () {
      var sum = 0
      const end = new Date(this.startDate[1]).getTime()
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              var finishDate = new Date(sale[c].finish_date).getTime()
              console.log('total giro cair date: ' + finishDate + ' ' + end)
              if (finishDate <= end) {
                console.log(sale[c].ref_no)
                sum += parseFloat(sale[c].subtotal)
              }
            }
          }
        }
      }
      return sum
    },
    totalSubtotalGiroBelumCair () {
      var sum = 0
      const end = new Date(this.startDate[1]).getTime()
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              var finishDate = new Date(sale[c].finish_date).getTime()
              if (finishDate > end) {
                sum += parseFloat(sale[c].subtotal)
              }
            }
          }
        }
      }
      return sum
    },
    totalDiscount () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 1) {
              sum += parseFloat(sale[c].discount)
            }
          }
        }
      }
      return sum
    },
    totalRounding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 1) {
              sum += parseFloat(sale[c].round)
            }
          }
        }
      }
      return sum
    },
    totalRoundingTunaiTransfer () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 1) {
              if (sale[c].account_type === 'transfer' || sale[c].account_type === 'tunai') {
                sum += parseFloat(sale[c].round)
              }
            }
          }
        }
      }
      return sum
    },
    totalRoundingPlus () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 1) {
              var round = parseFloat(sale[c].round)
              if (round > 0) {
                sum += parseFloat(round)
              }
            }
          }
        }
      }
      return sum
    },
    totalRoundingMinus () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 1) {
              var round = parseFloat(sale[c].round)
              if (round < 0) {
                sum += Math.abs(round)
              }
            }
          }
        }
      }
      sum = 0 - sum
      return sum
    },
    totalTunaiGroup () {
      var array = this.groups
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Tunai') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    countTunaiGroup () {
      var array = this.groups
      var count = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Tunai') {
          count += 1
        }
      }
      return count
    },
    totalTransferGroup () {
      var array = this.groups
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Transfer Bank') {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    countTransferGroup () {
      var array = this.groups
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method === 'Transfer Bank') {
          sum += 1
        }
      }
      return sum
    },
    totalGiroBelumCair () {
      const end = new Date(this.startDate[1]).getTime()
      console.log(end)
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].level === 1) {
              var finishDate = new Date(sale[c].finish_date).getTime()
              if (finishDate <= end) {
                if (sale[c].method === 'Giro') {
                  sum += parseFloat(sale[c].total)
                }
              }
            }
          }
        }
      }
      return sum
    },
    groupData () {
      var result = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let j = 0; j < area.length; j++) {
          var saleColl = area[j].saleColl
          for (let k = 0; k < saleColl.length; k++) {
            result.push(saleColl[k])
          }
        }
      }
      return result
    },
    groups () {
      var array1 = this.groupData.filter(d => d.level === 1)
      var array2 = this.groupData.filter(d => d.level === 2)
      var array3 = []
      var refNo = null
      for (let i = 0; i < array1.length; i++) {
        for (let j = 0; j < array2.length; j++) {
          if (array2[j].ref_no2 === array1[i].ref_no) {
            var total = 0
            if (refNo === array2[j].ref_no2) {
              total = 0
            } else {
              total = array1[i].total
            }
            var obj = {
              id: array2[j].id,
              area: array2[j].area,
              status: array1[i].status,
              type: array2[j].type,
              method_id: array1[i].method_id,
              method: array1[i].method,
              salesman_id: array2[j].salesman_id,
              salesman: array2[j].salesman,
              ref_no: array2[j].ref_no,
              ref_no2: array2[j].ref_no2,
              date: array2[j].date,
              due_date: array2[j].due_date,
              finish_date: array1[i].finish_date,
              age: array2[j].age,
              customer_no: array2[j].customer_no,
              customer: array2[j].customer,
              uangmuka: array2[j].uangmuka,
              retur_total: array2[j].retur_total,
              subtotal: array2[j].subtotal,
              discount: array2[j].discount,
              tax: array2[j].tax,
              round: array2[j].round,
              total: total,
              gross: array2[j].gross,
              payment_amount: array2[j].payment_amount,
              payment_total: array2[j].payment_total,
              outstanding: array2[j].outstanding,
              company_no: array2[j].company_no,
              company: array2[j].company,
              report_no: array2[j].report_no,
              report_count: array2[j].report_count,
              check_tanda_terima: array2[j].check_tanda_terima
            }
            refNo = array2[j].ref_no2
            array3.push(obj)
          }
        }
      }
      return array3
    },
    totalUangMuka () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Uang Muka') {
              sum += parseFloat(sale[c].total)
            }
          }
        }
      }
      return sum
    },
    totalUangMukaReport () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].report_count > 0) {
              if (sale[c].method === 'Uang Muka') {
                sum += parseFloat(sale[c].total)
              }
            }
          }
        }
      }
      // sum = sum + this.totalUangMukaTransferReport
      return sum
    },
    totalUangMukaPelunasan () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          sum += parseFloat(area[z].total_uangmuka_pelunasan)
        }
      }
      return sum
    },
    totalGiro () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              sum += parseFloat(sale[c].total)
            }
          }
        }
      }
      return sum
    },
    totalGiroReport () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].report_count > 0) {
              if (sale[c].method === 'Giro') {
                sum += parseFloat(sale[c].total)
              }
            }
          }
        }
      }
      return sum
    },
    totalTunai () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Tunai') {
              sum += parseFloat(sale[c].total)
              // sum += parseFloat(sale[c].uangmuka)
            }
          }
        }
      }
      sum = sum + this.totalUangMukaTunai
      return sum
    },
    totalDenda () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            sum += parseFloat(sale[c].penalty_amount)
          }
        }
      }
      return sum
    },
    totalTax () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            sum += parseFloat(sale[c].tax)
          }
        }
      }
      return sum
    },
    countTunai () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Tunai') {
              sum += 1
              // sum += parseFloat(sale[c].uangmuka)
            }
          }
        }
      }
      return sum
    },
    totalDiscountTunai () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Tunai') {
              sum += parseFloat(sale[c].discount)
            }
          }
        }
      }
      return sum
    },
    totalDiscountTransfer () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Transfer Bank') {
              sum += parseFloat(sale[c].discount)
            }
          }
        }
      }
      return sum
    },
    totalDiscountGiro () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Giro') {
              sum += parseFloat(sale[c].discount)
            }
          }
        }
      }
      return sum
    },
    totalDiscountUangMuka () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Uang Muka') {
              sum += parseFloat(sale[c].discount)
            }
          }
        }
      }
      return sum
    },
    totalTunaiReport () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        console.log(array[i])
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].report_count > 0) {
              if (sale[c].method === 'Tunai') {
                sum += parseFloat(sale[c].total)
                // sum += parseFloat(sale[c].uangmuka)
              }
            }
          }
        }
      }
      sum = sum + this.totalUangMukaTunaiReport
      return sum
    },
    totalTransfer () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Transfer Bank') {
              sum += parseFloat(sale[c].total)
              // sum += parseFloat(sale[c].uangmuka)
            }
          }
        }
      }
      sum = sum + this.totalUangMukaTransfer
      return sum
    },
    countTransfer () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].method === 'Transfer Bank') {
              sum += 1
            }
          }
        }
      }
      return sum
    },
    totalTransferReport () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].areas
        for (let z = 0; z < area.length; z++) {
          var sale = area[z].saleColl
          for (let c = 0; c < sale.length; c++) {
            if (sale[c].report_count > 0) {
              if (sale[c].method === 'Transfer Bank') {
                sum += parseFloat(sale[c].total)
                // sum += parseFloat(sale[c].uangmuka)
              }
            }
          }
        }
      }
      sum = sum + this.totalUangMukaTransferReport
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async showPaymentNo (id) {
      var payload = {
        group_no: id
      }
      this.$store.commit('SET_PAYMENT_BY_NO', payload)
      this.$store.dispatch('getPaymentByNo', payload)
    },
    async uncheckReportPayment (id, refNo) {
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        salesman: this.salesman_id,
        term: this.term,
        method_id: null
      }
      console.log(obj)
      console.log(reportUrl + '/payment-by-sales-area-date')
      await axios.post(reportUrl + '/payment-by-sales-area-date', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          for (let i = 0; i < this.dataRaw.length; i++) {
            var area = this.dataRaw[i].areas
            for (let a = 0; a < area.length; a++) {
              var sale = area[a].saleColl
              for (let b = 0; b < sale.length; b++) {
                if (sale[b].report_count > 0) {
                  this.selected.push(sale[b].id)
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport () {
      await this.$Progress.start()
      this.loader.isLoading = true
      for (let c = 0; c < this.selected.length; c++) {
        for (let b = 0; b < this.groupData.length; b++) {
          if (this.groupData[b].id === this.selected[c]) {
            var obj = {
              payment_no: this.groupData[b].ref_no,
              company_no: this.groupData[b].company_no,
              report_date: this.groupData[b].date,
              username: this.authUser.username,
              notes: null
            }
            await axios.post(reportTransactionUrl + '/create-payment-sales', obj, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
            var type = this.groupData[b].method_id
            var body = {
              id: this.groupData[b].id
            }
            if (type === 4) {
              console.log(paymentUrl + '/journal-sales-um')
              await axios.post(paymentUrl + '/journal-sales-um', body, { headers: getHeader() })
                .then(response => {
                  console.log(response.data.message)
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                  this.$swal('Error', error.response.data.message, 'error')
                })
            } else {
              if (this.groupData[b].category === 'all-sales') {
                await axios.post(paymentUrl + '/journal-all', body, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error', error.response.data.message, 'error')
                  })
              } else {
                await axios.post(paymentUrl + '/journal-sales', body, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                    this.$swal('Error', error.response.data.message, 'error')
                  })
              }
              // Update Customer rating
              await axios.post(customerUrl + '/sales-outstanding-expire', { customer_no: this.groupData[b].customer_no }, { headers: getHeader() })
                .then(response => {
                  console.log(response.data.message)
                })
                .catch(error => {
                  console.log(error)
                  console.log(error.response)
                })
            }
          }
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.refreshList()
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw,
        groups: this.groups,
        date: this.startDate[1]
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(report2Url + '/salesman-area')
      await axios.post(report2Url + '/salesman-area', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
